import ServiceBase from './ServiceBase';

export default class UserService extends ServiceBase {
    //async getUsers() {
    //    var results = await this.requestJson({
    //        url: `api/admin/user`,
    //        method: "GET"
    //    });

    //    return results;
    //}

    async getUser(id) {
        var result = await this.requestJson({
            url: `api/user/${id}`,
            method: "GET"
        });

        return result;
    }

    async updateUser(user) {
        var result = await this.requestJson({
            url: `api/user/${user.id}`,
            method: "PUT",
            data: user
        })

        return result;
    }

    async createUser(user) {
        var result = await this.requestJson({
            url: `api/user/`,
            method: "POST",
            data: user
        })

        return result;
    }

    async requestPasswordReset(userName) {
        var result = await this.requestJson({
            url: '/api/user/password/requestreset',
            method: 'POST',
            data: { username: userName}
        })

        return result;
    }

    async changePassword(resetPasswordVals) {
        var result = await this.requestJson({
            url: '/api/user/password',
            method: 'POST',
            data: resetPasswordVals
        });

        return result;
    }

    async getAvailableRoles(userType) {
        var result = await this.requestJson({
            url: `api/user/role`,
            method: 'POST',
            data: { userType: userType }
        });

        return result;
    }

    async getContactsForUser(queryParams) {
        var result = await this.requestJson({
            url: 'api/user/contacts',
            method: 'GET',
            data: queryParams
        })

        return result;
    }
}